
import React, { useState, useRef, useEffect } from 'react';

///style MUI
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Tooltip from '@mui/material/Tooltip';
///style bootstrap
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
///icon
import { TbDrone } from "react-icons/tb";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FolderOffIcon from '@mui/icons-material/FolderOff';


import TaskIcon from '@mui/icons-material/Task';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NoteAddIcon from '@mui/icons-material/NoteAdd';


export default function Drone_Status_Regulator(props) {
    const main_status = [props.status]; // รับเป็น Array
    // const [main_status, setmain_status] = useState(['อนุมัติเอกสาร']);

    return (
        <>
            <div >
                {main_status[0] === 'อนุมัติการลงทะเบียน' || main_status[0] === 'ไม่อนุมัติการลงทะเบียน'
                    ?
                    <>
                        {main_status[0] === 'อนุมัติการลงทะเบียน'
                            ?
                            <div className='center'>
                                <Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }}>อนุมัติ</span>} placement="top" >
                                    <FactCheckIcon style={{ width: "36px", height: "36px", color: "green", opacity: 0.9 }} />
                                </Tooltip>


                            </div>
                            :
                            <div className='center'>
                                <Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }} >ไม่อนุมัติ</span>} placement="top" >
                                    <FolderOffIcon style={{ width: "36px", height: "36px", color: "red", opacity: 0.75 }} />
                                </Tooltip>


                            </div>
                        }
                    </>
                    :
                    <Modal_Status status={main_status[0]} />
                }
            </div>
        </>


    )
}
const Modal_Status = (props) => {
    const [data_list_display, setdata_list_display] = useState([]);
    function process_checklist(status) {
        let data_list = [];
        if (status === 'ยังไม่อนุมัติ') {
            data_list = [{ Label: "ยื่นคำขอ", completed: true, active: false, error: false, icon: 1 },
            { Label: "รออนุมัติเอกสาร", completed: false, active: true, error: false, icon: 2 },//pending
            { Label: "อนุมัติการลงทะเบียน", completed: false, active: false, error: false, icon: 3 }]
        }
        if (status === 'อนุมัติเอกสาร') {
            data_list = [{ Label: "ยื่นคำขอ", completed: true, active: false, error: false, icon: 1 },
            { Label: "อนุมัติเอกสาร", completed: true, active: false, error: false, icon: 2 },
            { Label: "รออนุมัติการลงทะเบียน", completed: false, active: true, error: false, icon: 3 }]//pending
        }
        if (status === 'ไม่อนุมัติเอกสาร รอการแก้ไข') {
            data_list = [{ Label: "ไม่อนุมัติเอกสาร รอการแก้ไข", completed: false, active: true, error: false, icon: 1 }, //pending
            { Label: "อนุมัติเอกสาร", completed: false, active: false, error: false, icon: 2 },
            { Label: "อนุมัติการลงทะเบียน", completed: false, active: false, error: false, icon: 3 }]
        }
        return data_list;
    }
    function IconStep(props) {
        const { label, active, completed } = props;

        let icon;
        if (completed && !active) {
            icon = <TaskIcon style={{ width: "36px", height: "36px", color: "green", opacity: 0.9 }} />;
        } else if (completed && active) {
            icon = <TaskIcon style={{ width: "36px", height: "36px", color: "green", opacity: 0.9 }} />;
        } else if (!completed && active) {
            icon = <PendingActionsIcon style={{ width: "36px", height: "36px", color: "orange", opacity: 0.9 }} />;
        } else {
            icon = <AssignmentIcon style={{ width: "36px", height: "36px", color: "gray", opacity: 0.9 }} />;
        }

        return icon;
    }
    useEffect(() => {
        let datalist = process_checklist(props.status);
        setdata_list_display(datalist)
    }, [props.status]);


    return (
        <>

            <Stepper alternativeLabel  >
                {data_list_display.map((item) => (
                    <Step key={item.Label}>
                        <Tooltip title={<span style={{ fontSize: "16px", fontFamily: "Kanit" }}>{item.Label}</span>} placement="top" >
                            <StepLabel style={{ fontSize: "12px" }} StepIconComponent={(props) => <IconStep label={item.Label} {...item} />}>{ }</StepLabel>
                        </Tooltip>
                    </Step>
                ))}
            </Stepper>
        </>
    );

}
